import Joi from '@hapi/joi'

export const UpdateTemporaryCardValidationSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Operation Entity required`,
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Collection Point").messages({
        "any.invalid": `Supplier required`,
    }),
    fromDate: Joi.string().invalid("").required().label("From Date").messages({
        "any.required": `From Date required`,
    }),

}




    








